import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";
import HomePage from "./pages/Home";
import HowItWorksPage from "./pages/HowItWorks";
import WhatWeCheckPage from "./pages/WhatWeCheck";
import FreeSeoAuditPage from "./pages/FreeSeoAudit";
import DemoPage from "./pages/Demo";
import PrivacyPage from "./pages/Privacy";
import SeoRevenueLeakAuditPage from "./pages/SeoRevenueLeakAudit";
import TechnicalVisibilityAuditPage from "./pages/TechnicalVisibilityAudit";
import RequestAssessmentPage from "./pages/RequestAssessment";
import SeoAuditToolPage from "./pages/SeoAuditTool";
import CoreWebVitalsPage from "./pages/CoreWebVitalsCheck";
import TechnicalChecklistPage from "./pages/TechnicalSeoChecklist";
import WebsiteSeoCheckerPage from "./pages/WebsiteSeoChecker";
import NotFoundPage from "./pages/NotFound";
import { initAnalytics, trackPageView } from "./analytics";

const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isDevHost = hostname.includes("dev.") || hostname === "localhost";
const env = isDevHost ? "dev" : "prod";
const collectorUrl = "";

initAnalytics({ appId: "seo-audit-tool", env, collectorUrl });

const root = ReactDOM.createRoot(document.getElementById("root"));

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);
  return null;
}

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/how-it-works/index.html" element={<HowItWorksPage />} />
            <Route path="/what-we-check" element={<WhatWeCheckPage />} />
            <Route path="/what-we-check/index.html" element={<WhatWeCheckPage />} />
            <Route path="/free-seo-audit" element={<FreeSeoAuditPage />} />
            <Route path="/free-seo-audit/index.html" element={<FreeSeoAuditPage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/demo/index.html" element={<DemoPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/privacy/index.html" element={<PrivacyPage />} />
            <Route path="/seo-revenue-leak-audit" element={<SeoRevenueLeakAuditPage />} />
            <Route path="/seo-revenue-leak-audit/index.html" element={<SeoRevenueLeakAuditPage />} />
            <Route path="/technical-visibility-audit" element={<TechnicalVisibilityAuditPage />} />
            <Route path="/technical-visibility-audit/index.html" element={<TechnicalVisibilityAuditPage />} />
            <Route path="/request-assessment" element={<RequestAssessmentPage />} />
            <Route path="/request-assessment/index.html" element={<RequestAssessmentPage />} />
            <Route path="/seo-audit-tool" element={<SeoAuditToolPage />} />
            <Route path="/seo-audit-tool/index.html" element={<SeoAuditToolPage />} />
            <Route path="/core-web-vitals-check" element={<CoreWebVitalsPage />} />
            <Route path="/core-web-vitals-check/index.html" element={<CoreWebVitalsPage />} />
            <Route path="/technical-seo-checklist" element={<TechnicalChecklistPage />} />
            <Route path="/technical-seo-checklist/index.html" element={<TechnicalChecklistPage />} />
            <Route path="/website-seo-checker" element={<WebsiteSeoCheckerPage />} />
            <Route path="/website-seo-checker/index.html" element={<WebsiteSeoCheckerPage />} />
            <Route path="/app/*" element={<App />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
  </React.StrictMode>
);
